module.exports = __webpack_public_path__ + "static/what-carebits-is-banner-650d50f9ae280a540fd09a9d003a1f4f.png";